const HTTPS_LINK_RE = /(https:\/\/[^\s]+)/g;
const TRAILING_PUNCTUATION_RE = /[),.!?:;]+$/;

export const parseTextLinks = value => {
  if (!value) {
    return [];
  }

  const text = String(value);
  const parts = [];
  let lastIndex = 0;

  text.replace(HTTPS_LINK_RE, (match, url, index) => {
    if (index > lastIndex) {
      parts.push({
        type: 'text',
        value: text.slice(lastIndex, index),
      });
    }

    const trailingPunctuation = url.match(TRAILING_PUNCTUATION_RE);
    const href = trailingPunctuation ? url.slice(0, -trailingPunctuation[0].length) : url;

    parts.push({
      type: 'link',
      value: href,
    });

    if (trailingPunctuation) {
      parts.push({
        type: 'text',
        value: trailingPunctuation[0],
      });
    }

    lastIndex = index + match.length;
    return match;
  });

  if (lastIndex < text.length) {
    parts.push({
      type: 'text',
      value: text.slice(lastIndex),
    });
  }

  return parts;
};
